import { targetTotal, totalPayout } from "./quote";

export function msaTotalCFAInstallment(targetPrice, msaCfaCostPerThousand) {
  return (targetPrice * msaCfaCostPerThousand) / 1000;
}

export function distributedPayout(state, targetPrice) {
  return totalPayout(state) * (targetPrice / targetTotal(state));
}

export function msaTotalCfaInstallmentIncPayout(
  state,
  targetPrice,
  msaCfaCostPerThousand
) {
  return (
    ((targetPrice + distributedPayout(state, targetPrice)) *
      msaCfaCostPerThousand) /
    1000
  );
}
